/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_FallbackInputs */

const en_api_error_fallback = /** @type {(inputs: Api_Error_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred.`)
};

const pt_br2_api_error_fallback = /** @type {(inputs: Api_Error_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro inesperado.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred." |
*
* @param {Api_Error_FallbackInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_fallback = /** @type {((inputs?: Api_Error_FallbackInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_FallbackInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_fallback(inputs)
	return pt_br2_api_error_fallback(inputs)
});